import React, { useEffect, useRef } from "react";
import { MdOutlineArrowDropDown } from "react-icons/md";
import styled from "styled-components";

const SelectedStyled = styled.div` 
    &.select_deivce {
        position: relative;        
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 8px;
        height: 45px;
        max-height: 150px;    
        margin: 0; 

        .selectDevice {
            margin: 0;
            color: black;
            border: 0.5px solid #d5d5d5;
            border-radius: 6px;            
            width: ${(props => props.fullWidth ? "100%" : "calc(100% - 45px)")};
            overflow: auto;
             
            dl {                
                display: none;               
                margin: 0;
                float: left;
                width: 100%;
                box-sizing: border-box;
                padding: 8px;
                cursor: pointer;

                &.init {
                    display: flex;
                }

                span {
                    display: inline-block;
                    max-width: 100%;                    
                    margin: 0;
                    line-height: 24px;
                }

                svg {
                    display: inline-block;
                    width: 35px!important;
                    height: 24px!important;
                    margin: 0 0 0 auto;
                }

                &.audioOut { color: #0e9e32; }
                &.ok {
                    color: #0e9e32;
                    svg { color: #0e9e32; }
                }
                &.warning {
                    color: #ed1e1e;
                    svg { color: #ed1e1e; }
                }

                &:hover:not(&.init):not(&.temp), &.isSelect {
                    background: #b1b1b1!important;
                }
            }

            &.isSelected {         
                width: 100%;    
                top: 0; left: 0;
                position: absolute;
                background: #fff;
                display: flex;
                flex-direction: column;
                min-height: 45px;
                max-height: 150px;  
                z-index: 2;
                box-sizing: border-box;
                
                dl {
                    display: inline-flex;
                    background: #fff;
                    &.init { display: none; }
                }                 
            }
        }        
    }
`;

let handlerClick;
export function SelectDevice({ t, list, deviceId, setDeviceId, deviceStatus, children }) {
    const element = useRef();  
    
    useEffect(() => {
        return () => {
            window.removeEventListener('click', handleOutsideClick);
        }
    }, []);
    
    const handleOutsideClick = e =>{
        if (e.target.parentNode && !e.target.parentNode.closest('div.selectDevice')) close(element.current);
    }

    const open = (element) => {
        element && element.classList.add("isSelected");
    
        handlerClick = setTimeout(() => {
            window.addEventListener('click', handleOutsideClick);
        });
    }
    const close = (element) => {
        element && element.classList.remove("isSelected");
        if (handlerClick) {
            clearInterval(handlerClick);
        }
    }
     
    const onunfold = () => {
        if (list.length === 1 && list[0].label === '') return;
        const selectBox = element.current;
        if (selectBox.className.includes("isSelected")) close(selectBox);
        else open(selectBox);
    }

    const message = t(deviceStatus.message);
    const focusLabel = list.find(item => item.deviceId === deviceId)?.label;
    return (
        <SelectedStyled className="select_deivce nonSelect" fullWidth={!children ? true : false}>
            <div className="selectDevice" ref={element} onClick={onunfold}>
                <dl className={`init ${deviceStatus.type}`}> 
                    <span className="overText">
                        { deviceStatus.type !== 'warning' ? deviceId === 'default' && !focusLabel ? 'default' : focusLabel : message }
                    </span>
                    <MdOutlineArrowDropDown />
                </dl>
                { deviceStatus.type === 'warning' && <dl className="temp warning">{message}</dl> }
                { list.map((item, index) => {
                    const { deviceId: id, label } = item;
                    if ( label === '') return;
                    const onChange = () => setDeviceId(id);

                    return (
                        <dl key={index}
                            className={ id === deviceId ? "isSelect" : null }
                            value={id}
                            onClick={onChange}
                        ><span className="overText">{label}</span></dl>
                    )
                })}
            </div>
            <div>
                {children}
            </div>
        </SelectedStyled>
    )
}